import {VectorItemPanels} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-vector-options/poster-editing-vector-options.types';
import {useGetKeyFromAuraOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromAuraOfActiveItem';
import {useEffect} from 'react';
import {AuraType} from '@PosterWhiteboard/classes/item-aura.class';

export function useIsOpenedVectorPanelValid(currentlyOpenedColorPanel: VectorItemPanels, setCurrentlyOpenedPanel: (newVal: VectorItemPanels) => void): void {
  const auraType = useGetKeyFromAuraOfActiveItem('type');

  useEffect((): void => {
    if (auraType !== AuraType.CUSTOM_SHADOW && currentlyOpenedColorPanel === VectorItemPanels.CUSTOM_SHADOW) {
      setCurrentlyOpenedPanel(VectorItemPanels.NONE);
    }
  }, [auraType]);
}
